export default __webpack_public_path__ + "static/media/Skyshear Jerkin.df3ac450.jpg";